query populationCourses(
  $scenarioId: ID!
  $originId: ID!
  $termId: ID!
  $populationCode: String!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    populationCourses(termId: $termId, populationCode: $populationCode) {
      id
      code
      name
      canEdit
      tags
      courseComponents {
        id
        component {
          id
          code
          name
        }
      }
    }
  }
}
